/** CustomEvent name for duna-locations-and-rooms screen (open forms / delete). */
export const DUNA_LOCATIONS_ADMIN_EVENT = 'duna-locations-admin';
